import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState("clients", ["salesPersonList"])
  },
  methods: {
    FilterUsersRole(arr, role) {
      if (arr) {
        return arr.filter(user => user.role === role);
      }
      return this.salesPersonList.filter(user => user.role === role);
    }
  }
};
